import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FollowingQuery } from 'src/app/store/following/state/following.query';
import { FollowingState, FollowingStore } from 'src/app/store/following/state/following.store';
import { SubSink } from 'subsink';

type FollowingCheckbox = Partial<Record<keyof FollowingState, FormControl>>;
@Component({
  selector: 'app-following',
  templateUrl: './following.component.html',
  styleUrls: ['./following.component.scss'],
})
export class FollowingComponent implements OnInit, OnDestroy {
  formControls: FollowingCheckbox = {
    followCenterVehicle: new FormControl(),
  };
  subs = new SubSink();
  constructor(private store: FollowingStore, private query: FollowingQuery) {}

  ngOnInit() {
    this.subs.sink = this.formControls.followCenterVehicle.valueChanges.subscribe((state) =>
      this.store.update((x) => ({
        ...state,
        followCenterVehicle: this.formControls.followCenterVehicle.value,
      }))
    );
    this.subs.sink = this.query.select().subscribe((x) => {
      this.formControls.followCenterVehicle.patchValue(x.followCenterVehicle, {
        emitEvent: false,
      });
      if (!x.currentVechile) {
        this.formControls.followCenterVehicle.disable({ emitEvent: false });
      } else {
        if (this.formControls.followCenterVehicle.disabled) {
          this.formControls.followCenterVehicle.enable({ emitEvent: false });
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
